import React from 'react';
import { motion } from 'framer-motion';
import { Check, Timer } from 'lucide-react';
import { Button } from './ui/Button';
import { goToCheckout } from '../constants/checkout';
export function UrgencyOffer() {
  return <section className="py-24 bg-intense-red relative overflow-hidden" data-id="element-151">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23000000\' fill-opacity=\'0.2\' fill-rule=\'evenodd\'%3E%3Ccircle cx=\'3\' cy=\'3\' r=\'3\'/%3E%3Ccircle cx=\'13\' cy=\'13\' r=\'3\'/%3E%3C/g%3E%3C/svg%3E')] opacity-30" data-id="element-152"></div>
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/50 to-transparent" data-id="element-153"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-154">
        <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-155">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-156">
            <Timer className="w-8 h-8 text-white animate-pulse" data-id="element-157" />
            <h2 className="text-4xl md:text-5xl font-teko font-bold text-white uppercase tracking-wider" data-id="element-158">
              OFERTA ESPECIAL DE LANZAMIENTO
            </h2>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-10" data-id="element-159">
            <div className="text-center" data-id="element-160">
              <span className="text-gray-300 text-xl font-medium line-through block mb-2" data-id="element-161">
                Precio anterior: ARS 59.999
              </span>
              <div className="text-6xl md:text-7xl font-teko font-bold text-white drop-shadow-lg" data-id="element-162">
                ARS 39.999
              </div>
              <div className="bg-white text-intense-red font-bold text-sm uppercase px-4 py-1 rounded-full inline-block mt-4 shadow-lg" data-id="element-163">
                Ahorrás ARS 20.000
              </div>
            </div>

            <div className="w-full md:w-px h-px md:h-32 bg-white/20" data-id="element-164"></div>

            <div className="flex flex-col gap-3" data-id="element-165">
              {['Acceso inmediato', 'Material descargable', 'Bonus incluidos', 'Compra segura'].map((item, idx) => <div key={idx} className="flex items-center gap-3 text-white text-lg font-medium" data-id="element-166">
                  <div className="bg-white/20 p-1 rounded-full" data-id="element-167">
                    <Check className="w-5 h-5 text-white" data-id="element-168" />
                  </div>
                  {item}
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-169">
            <Button variant="primary" size="xl" className="w-full md:w-auto !bg-black !text-white hover:!bg-zinc-900 !border-2 !border-white shadow-[0_0_30px_rgba(0,0,0,0.5)]" onClick={goToCheckout} data-id="element-170">
              APROVECHAR OFERTA AHORA
            </Button>
          </div>
        </div>
      </div>
    </section>;
}